module.exports = __webpack_public_path__ + "images/Procedures_SS_297131921_bc9ab96.jpg";